var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-4" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.innerCode || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.name || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.name || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.retailerRealComName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.retailerRealComCode || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.prftCenterCode || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.fiscalQuantity || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.shopDevice.orgWorth == null
                  ? "无"
                  : _vm.shopDevice.orgWorth.toFixed(2)
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.shopDevice.netWorth == null
                  ? "无"
                  : _vm.shopDevice.netWorth.toFixed(2)
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(9),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.assetDeprMethodMap[_vm.shopDevice.deprMethodCode] || "无"
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(10),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.shopDevice.aggtDeprWorth == null
                  ? "无"
                  : _vm.shopDevice.aggtDeprWorth.toFixed(2)
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(11),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDevice.currentMonthDepr != null
            ? _c("span", [
                _vm._v(_vm._s(_vm.shopDevice.currentMonthDepr.toFixed(2)))
              ])
            : _c("span", [_vm._v("无")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(12),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDevice.deprSpecId != null && _vm.shopDevice.deprSpecId != -1
            ? _c("span", [
                _c(
                  "a",
                  {
                    staticClass: "table-cell-link",
                    on: {
                      click: function($event) {
                        _vm.showDeprSpec(_vm.shopDevice.deprSpecId)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.shopDevice.deprSpecCode))]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.shopDevice.deprMethodCode == "SLD" ||
      _vm.shopDevice.deprMethodCode == "ASM"
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(13),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "form-value" }, [
                _vm.shopDevice.cnt1stMonth
                  ? _c("span", { staticClass: "font-red" }, [_vm._v("首月")])
                  : _c("span", [_vm._v("次月")])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shopDevice.fiscalAcctFlag == 1
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(14),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _vm.shopDevice.deprOver
                ? _c("span", { staticClass: "font-red" }, [_vm._v("是")])
                : _c("span", [_vm._v("否")])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(15),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.leftMonths || 0))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(16),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.lastDeprMonth || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(17),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.initInnerCode || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(18),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.outerUnsettled ? "是" : "否"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(19),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.fiscalAbnormal ? "是" : "否"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(20),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.assetNatureMap[_vm.shopDevice.assetNature] || "无")
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(21),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.assetKindName || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(22),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.innerDevcCatCode || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(23),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.innerDevcCatName || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(24),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.durableLife || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(25),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.assetIdleX ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(26),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.reserved ? "已被预定" : "可以预定"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(27),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.indoubtFlag == 1 ? "是" : "否"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(28),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDevice.fiscalAcctFlag == 0
            ? _c("span", [_vm._v(_vm._s(_vm.shopDevice.durableYears || 0))])
            : _vm.shopDevice.deprable
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.shopDevice.durableLife - _vm.shopDevice.leftMonths || 0
                  )
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(29),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.acctEnterWayMap[_vm.shopDevice.acctEnterWay]))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(30),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDevice.price != null
            ? _c("span", [
                _vm._v(_vm._s(_vm.shopDevice.price.toFixed(2) || 0.0))
              ])
            : _c("span", [_vm._v("0.00")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(31),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDevice.ntxPrice != null
            ? _c("span", [
                _vm._v(_vm._s(_vm.shopDevice.ntxPrice.toFixed(2) || 0.0))
              ])
            : _c("span", [_vm._v("0.00")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(32),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.scrappedQuantity || 0))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(33),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.fiscalInTime || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(34),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.rmnWorthRatio || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(35),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.costCenterCode || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(36),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.multiDepartUsed ? "是" : "否"))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.shopDevice.multiDepartUsed
      ? _c(
          "div",
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.costCenterDeprAllocGroupList,
                  border: "",
                  "tooltip-effect": "dark",
                  height: "400"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "120px",
                    prop: "allocCostCenterCode",
                    label: "成本中心编码",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "200px",
                    prop: "allocCostCenterName",
                    label: "成本中心名称",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    width: "180px",
                    prop: "allocRatio",
                    label: "比例(%)"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.allocRatio == null
                                  ? null
                                  : parseFloat(scope.row.allocRatio).toFixed(2)
                              )
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "allocDepartNames",
                    label: "分摊业务部门",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    width: "200px",
                    prop: "memo",
                    label: "备注",
                    "show-overflow-tooltip": ""
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(37),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-4" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(38),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.tmpNo || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.tmpNo || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(39),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.innerNo || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.innerNo || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(40),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.devcDefNo || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.devcDefNo || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(41),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c(
            "span",
            { attrs: { title: _vm.shopDevice.initContractNo || "无" } },
            [_vm._v(_vm._s(_vm.shopDevice.initContractNo || "无"))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(42),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.sellerName || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.sellerName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(43),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _vm.shopDevice.suitMainFlag
              ? _c("el-tag", { attrs: { type: "success" } }, [_vm._v("主")])
              : _vm._e(),
            _vm._v(" "),
            _vm.shopDevice.tagMissing
              ? _c("el-tag", { attrs: { type: "warning" } }, [_vm._v("缺码")])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { attrs: { title: _vm.shopDevice.title || "无" } }, [
              _vm._v(_vm._s(_vm.shopDevice.title || "无"))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(44),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.brandName || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.brandName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(45),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.fixedSpec || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.fixedSpec || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(46),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.model || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.model || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(47),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.theUnit || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(48),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.vendorSn || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.vendorSn || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(49),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.createTime || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(50),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.buyDate || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(51),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.imported ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(52),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.importNo))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(53),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.receiveTime))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(54),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.receiptDate))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(55),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.batchNo))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(56),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.splitible ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(57),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.clearDate || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(58),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.clearCause || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(59),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { attrs: { title: _vm.shopDevice.upc || "无" } }, [
            _vm._v(_vm._s(_vm.shopDevice.upc || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.infoType == null || _vm.infoType == "change"
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(60),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.shopDevice.devcGroupFullName || ""))
              ])
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm._m(61),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-4" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(62),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.retailerBizUnitName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(63),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.retailerComFullName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(64),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.respblDepartName || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(65),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.respblStaffName || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(66),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.shopDevice.applyUseDepartFullName || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(67),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.applyUseStaffName || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(68),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.inStkQuantity))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(69),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.inUseQuantity))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(70),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.shopDevice.fiscalLocked || _vm.shopDevice.locked
                  ? "是"
                  : "否"
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(71),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDevice.fiscalLocked
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.devcVoucherTypeMap[_vm.shopDevice.fiscalLockBizType]
                  )
                )
              ])
            : _vm.shopDevice.locked
            ? _c("span", [
                _vm._v(
                  _vm._s(_vm.devcVoucherTypeMap[_vm.shopDevice.lockBizType])
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(72),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.shopDevice.fiscalLocked
                  ? _vm.shopDevice.fiscalLockBizInnerNo
                  : _vm.shopDevice.locked
                  ? _vm.shopDevice.lockBizInnerNo
                  : ""
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(73),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.scrapped ? "是" : "否"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(74),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.retailerComNo))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(75),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _vm._l(_vm.shopDevice.tagNames, function(tagName) {
              return [
                _c("span", { staticClass: "swb-tags swb-tags-success mr5" }, [
                  _vm._v(_vm._s(tagName))
                ])
              ]
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(76),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.shopDevice.assetType == 0 ? "单品式管理" : "批量式管理"
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(77),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDevice.locCode))])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(78),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-4" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(79),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDevice.imageUrl != null && _vm.shopDevice.imageUrl.length > 0
            ? _c("div", { staticClass: "file-area clearfix" }, [
                _c(
                  "div",
                  { staticClass: "file-item image viewable downloadable" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "file-content",
                        on: {
                          click: function($event) {
                            _vm.viewImage(_vm.shopDevice.imageUrl)
                          }
                        }
                      },
                      [
                        _c("img", { attrs: { src: _vm.shopDevice.imageUrl } }),
                        _vm._v(" "),
                        _vm._m(80)
                      ]
                    )
                  ]
                )
              ])
            : _c("div", [
                _c("img", {
                  directives: [
                    {
                      name: "resc-url",
                      rawName: "v-resc-url",
                      value: "/image/noimg.jpg",
                      expression: "'/image/noimg.jpg'"
                    }
                  ]
                })
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(81),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDevice.spotImageUrl != null &&
          _vm.shopDevice.spotImageUrl.length > 0
            ? _c("div", { staticClass: "file-area clearfix" }, [
                _c(
                  "div",
                  { staticClass: "file-item image viewable downloadable" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "file-content",
                        on: {
                          click: function($event) {
                            _vm.viewImage(_vm.shopDevice.spotImageUrl)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.shopDevice.spotImageUrl }
                        }),
                        _vm._v(" "),
                        _vm._m(82)
                      ]
                    )
                  ]
                )
              ])
            : _c("div", [
                _c("img", {
                  directives: [
                    {
                      name: "resc-url",
                      rawName: "v-resc-url",
                      value: "/image/noimg.jpg",
                      expression: "'/image/noimg.jpg'"
                    }
                  ]
                })
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.shopDevice.classifyTagId != null && _vm.shopDevice.classifyTagId != -1
      ? _c("div", { staticClass: "content-caption dashed" }, [
          _c("span", [_vm._v("自定义属性")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.shopDevice.classifyTagId != null && _vm.shopDevice.classifyTagId != -1
      ? _c(
          "div",
          { staticClass: "simple-form flex col-4" },
          _vm._l(_vm.propList, function(itemInfo) {
            return _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v(_vm._s(itemInfo.label))])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  itemInfo.type != null && itemInfo.type == "linkUrl"
                    ? [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.viewAsVideo(itemInfo.value)
                              }
                            }
                          },
                          [_vm._v(_vm._s(itemInfo.value))]
                        )
                      ]
                    : _c("span", [_vm._v(_vm._s(itemInfo.value || ""))])
                ],
                2
              )
            ])
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("记账基本信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所属公司")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司代码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("利润中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("原值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("净值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("折旧方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("累计折旧（元）")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当月折旧(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("折旧分摊规则编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("首次计提")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("折旧完毕")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("剩余折旧月数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("最后折旧月份")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("原始资产编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("未结算资产")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务异常")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产属性")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务类别")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("分类编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("使用年限（月）")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产闲置")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预定情况")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("账面不符")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已用年限（月）")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("入账方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("含税单价(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("未税单价(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("入账日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("残值率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否多部门使用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产基础信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("系统编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("外部系统编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产定义编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("初始合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供应商名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产描述全称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("品牌")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规格")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("型号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单位")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("厂商序列号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("购置日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("导入")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("导入记录号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("批次号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("可拆分")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("清除日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("清除原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("统一商品代码(UPC)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("维保分组")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("设备管理")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务单元")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("部门全称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("责任部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("责任人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("领用部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("领用人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在库数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("在用数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否锁定")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("锁定业务类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("锁定单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("报废/弃用")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("管理方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("位置编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产图片")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产图片")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "operation-group" }, [
      _c("i", { staticClass: "icon iconfont icon-chakan view" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("现场图片")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "operation-group" }, [
      _c("i", { staticClass: "icon iconfont icon-chakan view" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-565d4646", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565d4646","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devc/ShopDeviceAssetInfo.vue
// module id = 2512
// module chunks = 0